var __jsx = React.createElement;
import React from "react";
import classes from "./AffSection4.module.css";
import { useTranslation } from "@i18n";
var AffSection4 = function AffSection4() {
  var _useTranslation = useTranslation(["web_affiliate_program", "web_common"]),
    t = _useTranslation.t,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement("section", {
    className: classes.AffiliateSection4
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", classes.containerMaxWidh].join(" ")
  }, /*#__PURE__*/React.createElement("h2", {
    className: classes.sectionTitle
  }, t("how_promote_cars_syarah", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.howAff
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.singleHowAff
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/bundles/hwaff1.svg",
    alt: t("join_program", {
      ns: "web_affiliate_program"
    })
  }), /*#__PURE__*/React.createElement("h3", null, t("join_program", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("p", null, tLong("affiliate/join-creators", {
    ns: "web_affiliate_program"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.singleHowAff
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/bundles/hwaff2.svg",
    alt: t("promote_cars", {
      ns: "web_affiliate_program"
    })
  }), /*#__PURE__*/React.createElement("h3", null, t("promote_cars", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("p", null, tLong("affiliate/marketing-resources-benefits", {
    ns: "web_affiliate_program"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.singleHowAff
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/bundles/hwaff3.svg",
    alt: t("earn_commission", {
      ns: "web_affiliate_program"
    })
  }), /*#__PURE__*/React.createElement("h3", null, t("earn_commission", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("p", null, tLong("affiliate/earn-commission-amount", {
    ns: "web_affiliate_program"
  }))))));
};
export default AffSection4;